import * as _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Page from 'src/components/common/Page';
import Client from 'src/models/AP/Client';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import useFetch from 'use-http';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { FaRegSave } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { FaUserTie } from 'react-icons/fa';
import { VscGraph } from 'react-icons/vsc';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import CPNavBar from '../CPNavBar';
import CitySelect from '../components/CitySelect';
import CountrySelect from '../components/CountrySelect';
import FindClientDialog from  '../dialogs/FindClientDialog';
import ClientDocumentManagementDialog from '../dialogs/ClientDocumentManagementDialog';
import ClientAlreadyExistsWarningDialog from '../dialogs/ClientAlreadyExistsWarningDialog';
import ClientDoc from 'src/models/ClientDoc';
import { FaFolderOpen } from 'react-icons/fa';
import TsdiClient from 'src/models/AP/Client';
import { FormRow } from 'src/components/controls/forms/reactHookForm';
import TsdiClientInfo from 'src/models/AP/ClientInfo';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './ClientMaintenancePage.scss';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import ReportOptionsDialog from 'src/components/accounts-payable/dialogs/ReportOptionsDialog';
import PersonnelToast from 'src/components/personnel/components/PersonnelToast';

const ClientMaintenancePage = () => {
    const dispatch = useDispatch();
    const [masterServicesAgreementDate, setMasterServicesAgreementDate] = useState<Date | [Date, Date]>(null);
    const { get, post, put, del, response } = useFetch();
    const [clientDocs, setClientDocs] = useState<Array<ClientDoc>>([]);
    const { reset, register, handleSubmit, formState, errors } = useForm();
    const { register: registerClientInfoForm, reset: resetClientInfoForm, formState: formStateClientInfoForm, getValues: getValuesClientInfoForm, setValue: setValueClientInfoForm} = useForm();
    // tslint:disable-next-line:max-line-length
    const { watch: watchClientInfoFormSection2, register: registerClientInfoFormSection2, reset: resetClientInfoFormSection2, getValues: getValuesClientInfoFormSection2, formState: formStateClientInfoFormSection2, setValue: setValuesClientInfoFormSection2} = useForm();
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [clientInfo, setClientInfo] = useState<TsdiClientInfo>(undefined);
    const [currentMileageRate, setCurrentMileageRate] = useState<number>(undefined);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [totalClients, setTotalClients] = useState<number>(undefined);
    const [clientTypes, setClientTypes] = useState<{ code: number, description: string}[]>([]);
    const [useClientAddressForBilling, setUseClientAddressForBilling] = useState<boolean>(false);
    const [partnerAgreementRequired, setPartnerAgreementRequired] = useState<boolean>(false);
    const [ndaRequired, setNdaRequired] = useState<boolean>(false);
    const [masterServicesAgreementRequired, setMasterServicesAgreementRequired] = useState<boolean>(false);
    const [subConsultantAgreementRequired, setSubConsultantAgreementRequired] = useState<boolean>(false);
    const [noGiftPolicy, setNoGiftPolicy] = useState<boolean>(false);
    const [workOrderRequired, setWorkOrderRequired] = useState<boolean>(false);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);
    const [pendingNavigation, setPendingNavigation] = useState<'next' | 'last' | null>(null);
    const [clientPositionInput, setClientPositionInput] = useState<string>('');
    const [clientPositionError, setClientPositionError] = useState<string>('');
    const [totalClientTableCount, setTotalClientTableCount] = useState<number>(0);
    const [pendingClientPayload, setPendingClientPayload] = useState<TsdiClient>(null);
    const [addingClient, setAddingClient] = useState<boolean>(false);
    const [tsdiAccounts, setTsdiAccounts] = useState<{ code: number, description: string}[]>(undefined);
    const { isDirty } = formState;
    const { isDirty: isDirtyClientInfoForm } = formStateClientInfoForm;
    const { isDirty: isDirtyClientInfoFormSection2 } = formStateClientInfoFormSection2;
    const [toast, setToast] = useState<{ message: string; color?: string, persistent?: boolean; } | null>(null);
    const showMsaDateEntry = watchClientInfoFormSection2('masterServicesAgreement');
    // TODO: Finish billing code validation
    // const [timeAndExpenseToken, setTimeAndExpenseToken] = useState<string>('');
    // const [clientValidations, setClientValidations] = useState<Array<boolean>>([]);

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!clientInfo) {
            if (clientInfo?.useBillingAddress !== undefined) {
                setUseClientAddressForBilling(clientInfo?.useBillingAddress);
            }
            if (clientInfo?.partnerAgreementRequired !== undefined) {
                setPartnerAgreementRequired(clientInfo?.partnerAgreementRequired);
            }
            if (clientInfo?.subConsultantAgreement !== undefined) {
                setSubConsultantAgreementRequired(clientInfo?.subConsultantAgreement);
            }
            if (clientInfo?.masterServicesAgreement !== undefined) {
                setMasterServicesAgreementRequired(clientInfo?.masterServicesAgreement);
            }
            if (clientInfo?.partnerAgreementRequired !== undefined) {
                setPartnerAgreementRequired(clientInfo?.partnerAgreementRequired);
            }
            if (clientInfo?.noGiftPolicy !== undefined) {
                setNoGiftPolicy(clientInfo?.noGiftPolicy);
            }
            if (clientInfo?.workOrderRequired !== undefined) {
                setWorkOrderRequired(clientInfo?.workOrderRequired);
            }
            if (clientInfo?.ndaRequired !== undefined) {
                setNdaRequired(clientInfo?.ndaRequired);
            }
            if (!!clientInfo?.masterServicesAgreementDate) {
                setMasterServicesAgreementDate(new Date(clientInfo.masterServicesAgreementDate));
            }
            const section2Values = getValuesClientInfoFormSection2();
            console.log(section2Values);
            resetClientInfoForm(clientInfo);
            resetClientInfoFormSection2(clientInfo);
        }
    }, [clientInfo]);

    useEffect(() => {
        if (!!addingClient) {
            showDialog(DialogList.FIND_CLIENT);
        }
    }, [addingClient]);

    useEffect(() => {
        if (!!selectedClient && !isNaN(selectedClient.clientNumber)) {
            reset({ clientNumber: selectedClient?.clientNumber, clientName: selectedClient?.clientName });

            getClientInfo(selectedClient?.clientNumber);
            // Previously gated behind `clients?.length > 0`, so a client selected before `clients`
            // was ever populated (e.g. via the shared ClientProjectSearch dropdown on first load,
            // with no client restored from localStorage) left `clients` permanently empty -
            // silently breaking Show First/Previous/Next/Last, which all walk this array.
            const displayClient = clients?.find((c) =>
                c.clientNumber === selectedClient?.clientNumber
            );
            if (displayClient !== undefined) {
                reset(displayClient);
            } else {
                setClientSearchTerm(selectedClient?.clientNumber?.toString());
            }
        }
    }, [selectedClient]);

    useEffect(() => {
        if (!!clientSearchTerm || clientSearchTerm === '') {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!clients && clients?.length > 0) {
            if (clients.length === 1 && clients[0].clientNumber === selectedClient?.clientNumber ) {
                const displayClient = clients.find((c) =>
                    c.clientNumber === selectedClient?.clientNumber
                );
                if (displayClient !== undefined) {
                    reset(displayClient);
                }
            } else if (clients.length === 1 && !isNaN(Number(clients?.[0]?.clientNumber))) {
                setSelectedClient(clients[0]);
            }
        }
    }, [clients]);

    // Resolves the page(s) requested by moveToNextClient/moveToLastClient once they land - 'next'
    // advances one row past the previously-selected client (now that the page containing it has
    // arrived); 'last' keeps paging in further pages (incrementClients again) until the full result
    // set is loaded, then lands on its true final row.
    useEffect(() => {
        if (!pendingNavigation || !clients?.length) {
            return;
        }
        if (pendingNavigation === 'next') {
            setPendingNavigation(null);
            const selectedClientIndex = clients.findIndex(c => c.clientNumber === selectedClient?.clientNumber);
            if (selectedClientIndex >= 0 && selectedClientIndex + 1 < clients.length) {
                setSelectedClient(clients[selectedClientIndex + 1]);
            }
        } else if (pendingNavigation === 'last') {
            if (clients.length < (totalClients ?? clients.length)) {
                incrementClients();
            } else {
                setPendingNavigation(null);
                setSelectedClient(clients[clients.length - 1]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clients]);

    const moveToFirstClient = () => {
        if (clients?.length !== undefined && clients.length > 0) {
            setSelectedClient(clients[0]);
        }
    };

    const moveToLastClient = () => {
        if (clients?.length !== undefined && clients.length > 0) {
            if (clients.length < (totalClients ?? clients.length)) {
                // More pages exist beyond what's loaded - keep paging in (see the [clients] effect
                // below) until the full result set is loaded, then land on its actual last row.
                setPendingNavigation('last');
                incrementClients();
            } else {
                setSelectedClient(clients[clients.length - 1]);
            }
        }
    };

    const moveToNextClient = () => {
        if (clients?.length !== undefined && clients.length > 0) {
            const selectedClientIndex = clients.findIndex(c => c.clientNumber === selectedClient?.clientNumber);
            if (selectedClientIndex < 0) {
                setSelectedClient(clients[0]);
            } else if (selectedClientIndex + 1 < clients.length) {
                setSelectedClient(clients[selectedClientIndex + 1]);
            } else if (clients.length < (totalClients ?? clients.length)) {
                // Reached the end of the currently loaded page but more results exist server-side -
                // page in the next set (see the [clients] effect below) and advance once it lands.
                setPendingNavigation('next');
                incrementClients();
            }
        }
    };

    const moveToPreviousClient = () => {
        if (clients?.length !== undefined && clients.length > 0) {
            const selectedClientIndex = clients.findIndex(c => c.clientNumber === selectedClient?.clientNumber);
            if (selectedClientIndex < 0) {
                setSelectedClient(clients[clients.length - 1]);
            } else if (selectedClientIndex >= 1) {
                setSelectedClient(clients[selectedClientIndex - 1]);
            }
        }
    };

    // Keeps the jump-to input in sync whenever the position changes via the nav buttons or a fresh
    // client list loads - mirrors VendorsPage.tsx's own vendorPositionInput effect.
    useEffect(() => {
        const index = clients?.findIndex(c => c.clientNumber === selectedClient?.clientNumber) ?? -1;
        setClientPositionInput(clients?.length && index >= 0 ? String(index + 1) : '');
        setClientPositionError('');
    }, [selectedClient, clients]);

    // Debounced so only actual keystrokes trigger a jump, same as VendorsPage.tsx's
    // jumpToVendorPosition. Position is 1-based, against the clients currently loaded in this
    // search (same list Next/Previous/Last already page through) - not the Client # column.
    const jumpToClientPosition = useRef(_.debounce((rawValue: string) => {
        const trimmed = rawValue.trim();

        if (!trimmed) {
            setClientPositionError('');
            return;
        }

        if (!/^\d+$/.test(trimmed)) {
            setClientPositionError('Must be a whole number.');
            return;
        }

        const enteredPosition = parseInt(trimmed, 10);
        const count = clients?.length ?? 0;

        if (count === 0) {
            setClientPositionError('No clients are loaded.');
            return;
        }

        if (enteredPosition < 1 || enteredPosition > count) {
            setClientPositionError(`Must be between 1 and ${count}.`);
            return;
        }

        setClientPositionError('');
        setSelectedClient(clients[enteredPosition - 1]);
    }, 500)).current;

    const handleClientPositionInputChange = (event: React.FormEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value;
        setClientPositionInput(value);
        jumpToClientPosition(value);
    };

    const getClientInfo = async (clientNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/info/${clientNumber}`);

        if (response.ok) {
            setClientInfo(result);
        } else {
            setClientInfo(new TsdiClientInfo());
            console.log('Unable to get client info data!');
        }
    };

    const getCurrentMileageRate = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/billing/mileagerate/current`);

        if (response.ok) {
            setCurrentMileageRate(result);
        } else {
            setCurrentMileageRate(.7);
            console.log('Unable to get mileage rate!');
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('ClientName', ODataOrderByDirection.Ascending));
    };

/*     const addClient = async (payload: Client) => {
        let result = await post(`/v1.0/AccountsPayable/clients`, payload);

        if (response.ok) {
            console.log('successfully added a client ' + result);
        } else {
            console.log('Unable to get client data!');
        }
    }; */

    const updateClientInfo = async (data: TsdiClientInfo) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/client/info`, data);

        if (!response.ok) {
            alert('Unable to update client info data: ' + result);
        } else {
            setSelectedClient(selectedClient);
        }
    };

    const addTsdiClient = async (payload: Client) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/client`, payload);

        if (response.ok) {
            getClientInfo(result);
            hideDialog();
            showToast('Client added successfully');
        } else {
            showToast('Add Client failed: ' + response.data, `rgba(255,0,0,0.5)`);
        }
    };

    const getCityStateFromZip = async (zipCode: string, cityField: string, stateField: string) => {
        let result = await get(`/v1.0/usps/${zipCode}/local-source`);

        if (response.ok) {
            // Only fill City if the user hasn't already entered/selected one - a manually chosen
            // City (or one carried over from an existing record) should never be silently
            // overwritten just because the zip was retyped. State keeps auto-filling unconditionally.
            const currentCity = getValuesClientInfoForm(cityField);
            if (!currentCity) {
                setValueClientInfoForm(cityField, result.zipCode.city, { shouldDirty: true });
            }
            setValueClientInfoForm(stateField, result.zipCode.state, { shouldDirty: true });
        }
    };

    const handleZipCodeChange = (e: React.FormEvent<HTMLInputElement>) => {
        const zipCode = e.currentTarget.value;
        if (zipCode.length === 5) {
            getCityStateFromZip(zipCode, 'city', 'state');
        }
    };

    const handleBillingZipCodeChange = (e: React.FormEvent<HTMLInputElement>) => {
        const zipCode = e.currentTarget.value;
        if (zipCode.length === 5) {
            getCityStateFromZip(zipCode, 'billingCity', 'billingState');
        }
    };

    const getBillingAccounts = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/accounts`);

        if (response.ok) {
            setTsdiAccounts(result);
        } else {
            console.log('Unable to get Billing Accounts Data!!!');
        }
    };

    // The true count of unique CL_NO rows in CLIENT - independent of whatever search/filter is
    // currently narrowing the `clients` array, unlike totalClients (which reflects the last
    // search's own result count). Fetched once; the CLIENT table's row count isn't expected to
    // change meaningfully within a single session.
    const getTotalClientCount = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/clients/count`);

        if (response.ok) {
            setTotalClientTableCount(Number(result) || 0);
        } else {
            console.log('Unable to get total client count!');
        }
    };

    const incrementClients = () => {
        if (!!fetchNextPage) {
            let newSearchOptions = _.cloneDeep(clientSearchOptions);
            newSearchOptions.incrementPageNumber();
            setClientSearchOptions(newSearchOptions);
        }
    };

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log('VouchersPage onCreate()');
        setAddingClient(false);
        getClientTypes();
        getBillingAccounts();
        initializeClientSearchSettings();
        getCurrentMileageRate();
        getTotalClientCount();
        const storedClientNumber = localStorage.getItem('backOfficeSelectedClientNumber');
        const storedClientName = localStorage.getItem('backOfficeSelectedClientName');
        if (!!storedClientNumber && !isNaN(Number(storedClientNumber)) && !!storedClientName) {
            getClientInfo(Number(storedClientNumber));
            reset({ clientNumber: storedClientNumber, clientName: storedClientName });
            setClientSearchTerm(storedClientNumber);
        }
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('VouchersPage onDestroy()');
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const onCancel = () => {
        setAddingClient(false);
        dispatch(actions.layout.hideDialog());
    };

    const hideDialog = () => {
        setAddingClient(false);
        dispatch(actions.layout.hideDialog());
    };

    // Port of CL_PR.fmt's DOCS field double-click (opens the Documents window scoped to
    // cd_type=1/cd_id=CL_NO). Mirrors VendorsPage.tsx's getVendorDocs/handleAddVendorDoc/
    // handleDeleteVendorDoc/handleDownloadVendorDoc.
    const getClientDocs = async (clientNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/${clientNumber}/documents`);

        if (response.ok) {
            setClientDocs(Array.isArray(result) ? result : []);
        } else {
            setClientDocs([]);
            console.log('Unable to get client documents!!!');
        }
    };

    const showDocumentManagement = () => {
        if (!selectedClient?.clientNumber) {
            return;
        }
        getClientDocs(selectedClient.clientNumber);
        showDialog(DialogList.MANAGE_CLIENT_DOCUMENTS);
    };

    const handleAddClientDoc = async (description: string, file: File) => {
        const clientNumber = selectedClient?.clientNumber;
        if (!clientNumber) {
            return;
        }

        // Raw fetch (matching VendorsPage.tsx's handleAddVendorDoc) since this sends the file's raw
        // bytes as the body - use-http's post() is built around JSON payloads.
        const params = new URLSearchParams({ description: description || '', fileName: file.name });
        const baseUrl = process.env.REACT_APP_BASE_API_URL;
        const url = `${baseUrl}/v1.0/ClientProjectMaintenance/client/${clientNumber}/documents?${params}`;
        const jwtToken = localStorage.getItem('jwt') || sessionStorage.getItem('jwt');

        try {
            const result = await fetch(url, {
                method: 'POST',
                body: file,
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    'Content-Type': file.type || 'application/octet-stream'
                }
            });

            if (result.ok) {
                getClientDocs(clientNumber);
                getClientInfo(clientNumber);
            } else {
                console.log('Unable to add client document!!!');
            }
        } catch (e) {
            console.log('Unable to add client document!!!', e);
        }
    };

    const handleDeleteClientDoc = async (docId: number) => {
        const clientNumber = selectedClient?.clientNumber;
        let result = await del(`/v1.0/ClientProjectMaintenance/client/documents/${docId}`);

        if (response.ok) {
            getClientDocs(clientNumber);
            getClientInfo(clientNumber);
        } else {
            console.log('Unable to delete client document!!!' + result);
        }
    };

    const downloadBlobResponseAsFile = (blob: Blob, fileName: string) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'document';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    };

    const handleDownloadClientDoc = async (doc: ClientDoc) => {
        if (doc.hasBlob) {
            await get(`/v1.0/ClientProjectMaintenance/client/documents/${doc.id}/blob`);
        } else {
            // Same generic S3BucketController.GetFile endpoint VendorsPage.tsx's
            // handleDownloadVendorDoc uses - no client-specific S3 download route needed.
            await get(`/v1.0/s3bucket/${encodeURIComponent(doc.s3Key)}`);
        }

        if (response.ok) {
            const blob = await response.blob();
            downloadBlobResponseAsFile(blob, doc.originalFileName);
        } else {
            console.log('Unable to download client document!!!');
        }
    };

    const reportOptions = () => {
        showDialog(DialogList.REPORT_OPTIONS);
    };

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            // Page 1 is always a fresh search (replace); any later page came from incrementClients()
            // paging in more of the SAME search, so it's appended onto what's already loaded -
            // otherwise Next/Last would lose every earlier page each time another one comes in.
            const isFirstPage = (clientSearchOptions?.getPageNumber() ?? 1) <= 1;
            setClients((prev) => isFirstPage ? result.items : [...(prev ?? []), ...(result.items ?? [])]);
            setTotalClients(result.totalRecords);
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const getClientTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/clients/types`);

        if (response.ok) {
            setClientTypes([]);
            setClientTypes(result);
        } else {
            setClientTypes([]);
            console.log('Unable to get client type data!');
        }
    };

    const resetClientSearchOptions = () => {
        setFetchNextPage(true);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        if (typeof clientSearchTerm === 'string') {
            const fieldValues = clientSearchTerm.split(',');
            if (fieldValues[0] !== undefined && !isNaN(Number(fieldValues[0]))) {
                newClientSearchOptions.addFilter(new ODataFilter('ClientNumber', ODataFilterOperators.Equals, !!clientSearchTerm ? fieldValues[0] : ''));
            }
            if (fieldValues[1] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('ClientName', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[1] : ''));
            }
            if (fieldValues[2] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('Address', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[2] : ''));
            }
            if (fieldValues[3] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[3] : ''));
            }
            if (fieldValues[4] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[4] : ''));
            }
            if (fieldValues[5] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[5] : ''));
            }
            if (fieldValues[6] !== undefined) {
                newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[6] : ''));
            }
        }
        setClientSearchOptions(newClientSearchOptions);
    };

    const findClient = (addNewClient: boolean) => {
        if (!!addNewClient) {
            setAddingClient(true);
        } else {
            setAddingClient(false);
            showDialog(DialogList.FIND_CLIENT);
        }
    };

    // FindClientDialog's Add Client mode found an exact name match among the clients it already
    // has loaded (its own live name-filtered search) - warn instead of silently allowing a
    // duplicate. `addingClient` is already true at this point (never toggled off mid-add), so the
    // usual [addingClient] effect that opens FIND_CLIENT won't re-fire on its own once the warning
    // closes - closeDuplicateClientNameWarning re-shows it explicitly instead. The payload FindClientDialog
    // hands over (built from its own current form values, not any clicked row) is held here so OK can
    // actually complete the save with it.
    const handleDuplicateClientName = (payload: TsdiClient) => {
        setPendingClientPayload(payload);
        showDialog(DialogList.CLIENT_NAME_EXISTS);
    };

    const confirmDuplicateClientCreate = () => {
        if (pendingClientPayload) {
            addTsdiClient(pendingClientPayload);
        }
        setPendingClientPayload(null);
    };

    const closeDuplicateClientNameWarning = () => {
        setPendingClientPayload(null);
        showDialog(DialogList.FIND_CLIENT);
    };

    const displayTitle = () => {
        const title = 'Client Maintenance';

        return title;
    };

    const handleReport = () => {
        alert('Not implemented!');
    };

    const setMsaDateDirty = (date: Date | [Date, Date]) => {
        setValuesClientInfoFormSection2('masterServicesAgreementDatePicker', date, {
            shouldDirty: true
          });
        setMasterServicesAgreementDate(date);
    };

    const showToast = (message: string, color?: string, persistent?: boolean) => {
        setToast({ message, persistent, color });
    };

    const displayClientInfo = () => {
        return (
            <>
            <form className="client-address-form">
                <div style={{display: 'inline-block', marginTop: '1rem'}}>
                    <RHFInputBox
                        labelOnLeft={true}
                        label="Name"
                        name={'clientName'}
                        style={{width: '100%'}}
                        bodyStyle={{width: '100%'}}
                        register={registerClientInfoForm}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        label="Address"
                        name={'address'}
                        style={{width: '100%'}}
                        bodyStyle={{width: '100%'}}
                        register={registerClientInfoForm}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        label=" "
                        name={'address2'}
                        style={{width: '100%'}}
                        bodyStyle={{width: '100%'}}
                        register={registerClientInfoForm}
                    />
                    <RHFInputBox
                        labelOnLeft={true}
                        label=" "
                        name={'address3'}
                        style={{width: '100%'}}
                        bodyStyle={{width: '100%'}}
                        register={registerClientInfoForm}
                    />
                    <div style={{display: 'flex'}}>
                        <div className="form-row" style={{width: '65%'}}>
                            <label htmlFor="country" style={{marginRight: '1rem'}}>Country</label>
                            <CountrySelect
                                name={'country'}
                                defaultCountry={clientInfo?.country}
                                register={registerClientInfoForm}
                                setValue={setValueClientInfoForm}
                                bodyStyle={{width: '100%'}}
                            />
                        </div>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Postal Code"
                            labelStyle={{width: 'auto', marginRight: '.5rem'}}
                            name={'zipCode'}
                            style={{width: '100%'}}
                            bodyStyle={{width: '35%'}}
                            register={registerClientInfoForm}
                            onChange={handleZipCodeChange}
                        />
                    </div>
                    <div style={{display: 'flex'}}>
                        <div className="form-row" style={{width: '75%', marginRight: '1.5rem'}}>
                            <label htmlFor="city" style={{marginRight: '1rem'}}>City</label>
                            <CitySelect
                                name={'city'}
                                defaultCity={clientInfo?.city}
                                register={registerClientInfoForm}
                                setValue={setValueClientInfoForm}
                                bodyStyle={{width: '100%'}}
                            />
                        </div>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="State"
                            labelStyle={{width: 'auto', marginRight: '.5rem'}}
                            name={'state'}
                            style={{width: '60px'}}
                            bodyStyle={{width: '25%'}}
                            register={registerClientInfoForm}
                        />
                    </div>
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Website/Email"
                            name={'emailAddress'}
                            style={{width: '100%'}}
                            bodyStyle={{width: '100%'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Phone"
                            name={'phone'}
                            style={{width: '150px'}}
                            bodyStyle={{width: '100%'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            labelOnLeft={true}
                            label="Fax"
                            name={'fax'}
                            style={{width: '150px'}}
                            bodyStyle={{width: '100%'}}
                            register={registerClientInfoForm}
                        />
                    </div>
                </form>
            </>
        );
    };

    const displayClientBillingAddress = () => {
        return (
            <>
                <form className="client-address-form">
                    <div style={{display: 'inline-block', marginTop: '1rem'}}>
                        <RHFCheckbox
                            label="Use Billing Address?"
                            labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                            name="useBillingAddress"
                            checked={useClientAddressForBilling}
                            register={registerClientInfoForm}
                            bodyStyle={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                            errors={errors}
                            onChange={() => setUseClientAddressForBilling(!useClientAddressForBilling)}
                        />
                        <RHFInputBox
                            type={'password'}
                            readOnly={!useClientAddressForBilling}
                            labelOnLeft={true}
                            label="Name"
                            name={'billingClientName'}
                            style={{width: '200px'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            type={'password'}
                            readOnly={!useClientAddressForBilling}
                            labelOnLeft={true}
                            label="Address"
                            name={'billingAddress'}
                            style={{width: '200px'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            type={'password'}
                            readOnly={!useClientAddressForBilling}
                            labelOnLeft={true}
                            label=" "
                            name={'billingAddress2'}
                            style={{width: '200px'}}
                            register={registerClientInfoForm}
                        />
                        <RHFInputBox
                            type={'password'}
                            readOnly={!useClientAddressForBilling}
                            labelOnLeft={true}
                            label=" "
                            name={'billingAddress3'}
                            style={{width: '200px'}}
                            register={registerClientInfoForm}
                        />
                        <div style={{display: 'flex'}}>
                            <div className="form-row" style={{width: '65%'}}>
                                <label htmlFor="billingCountry" style={{marginRight: '1rem'}}>Country</label>
                                <CountrySelect
                                    name={'billingCountry'}
                                    defaultCountry={clientInfo?.billingCountry}
                                    isDisabled={!useClientAddressForBilling}
                                    register={registerClientInfoForm}
                                    setValue={setValueClientInfoForm}
                                    bodyStyle={{width: '100%'}}
                                />
                            </div>
                            <RHFInputBox
                                type={'password'}
                                readOnly={!useClientAddressForBilling}
                                labelOnLeft={true}
                                label="Postal Code"
                                name={'billingZipCode'}
                                style={{width: '100%'}}
                                bodyStyle={{width: '35%', marginLeft: 'auto'}}
                                register={registerClientInfoForm}
                                onChange={handleBillingZipCodeChange}
                            />
                        </div>
                        <div style={{display: 'flex'}}>
                            <RHFInputBox
                                type={'password'}
                                readOnly={!useClientAddressForBilling}
                                labelOnLeft={true}
                                label="City"
                                name={'billingCity'}
                                style={{width: '40%'}}
                                bodyStyle={{width: '100%'}}
                                register={registerClientInfoForm}
                            />
                            <RHFInputBox
                                type={'password'}
                                readOnly={!useClientAddressForBilling}
                                labelOnLeft={true}
                                label="State"
                                name={'billingState'}
                                style={{width: '50px'}}
                                bodyStyle={{marginLeft: 'auto'}}
                                register={registerClientInfoForm}
                            />
                        </div>
                    </div>
                </form>
            </>
        );
    };

    const displayClientConfiguration = () => {
        return (
            <>
                <form>
                        <FormRow style={{marginTop: 0, alignItems: 'center'}}>
                            {/* Each item gets its own width:'auto' wrapper - .form-field's global
                                width:100% (see the note further down) resolves to auto against an
                                indefinite-width parent, so it just sizes to its own content instead
                                of fighting its neighbors for space. */}
                            <div style={{width: 'auto', flexShrink: 0, marginRight: '2rem'}}>
                                {clientTypes && <RHFSelect
                                    labelOnLeft={true}
                                    label="Client Type:"
                                    name={`clientFormatType`}
                                    defaultVal={`Oil & Gas Land`}
                                    options={clientTypes?.map(ct => {
                                        return { value: ct.code, label: ct.description };
                                        })}
                                    register={registerClientInfoFormSection2}
                                    errors={errors}
                                    style={{ width: '160px' }}
                                    bodyStyle={{whiteSpace: 'nowrap', width: 'auto' }}
                                />}
                            </div>
                            <div style={{width: 'auto', flexShrink: 0, marginRight: '2rem'}}>
                                <RHFInputBox
                                    labelOnLeft={true}
                                    label="Attached Documents"
                                    labelStyle={{width: 'auto', marginRight: '1rem'}}
                                    name={'attachedDocuments'}
                                    style={{
                                        width: '25px',
                                        textAlign: 'center',
                                        backgroundColor: (clientInfo?.attachedDocuments ?? 0) > 0 ? '#cfe8fa' : undefined,
                                        cursor: (clientInfo?.attachedDocuments ?? 0) > 0 ? 'pointer' : undefined,
                                    }}
                                    register={registerClientInfoForm}
                                    bodyStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle', width: 'auto'}}
                                    readOnly={true}
                                    onDoubleClick={() => showDocumentManagement()}
                                    title="Double-click to manage documents"
                                />
                            </div>
                            <div style={{width: 'auto', flexShrink: 0, marginRight: '6rem'}}>
                                <RHFCheckbox
                                    label="Work Order Required?"
                                    style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    name={`workOrderRequired`}
                                    checked={workOrderRequired}
                                    onChange={() => setWorkOrderRequired(!workOrderRequired)}
                                    register={registerClientInfoFormSection2}
                                    bodyStyle={{ verticalAlign: 'middle', width: 'auto' }}
                                    errors={errors}
                                />
                            </div>
                            <div style={{width: 'auto', flexShrink: 0}}>
                                <RHFCheckbox
                                    label="No Gift Policy?"
                                    style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    name={`noGiftPolicy`}
                                    checked={noGiftPolicy}
                                    onChange={() => setNoGiftPolicy(!noGiftPolicy)}
                                    register={registerClientInfoFormSection2}
                                    bodyStyle={{ verticalAlign: 'middle', width: 'auto' }}
                                    errors={errors}
                                />
                            </div>
                        </FormRow>
                        <div style={{whiteSpace: 'nowrap', display: 'flex', flexDirection: 'row', justifyContent: 'left'}}>
                            <RHFCheckbox
                                label="Master Services Agreement Required?"
                                style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                name={'masterServicesAgreement'}
                                checked={masterServicesAgreementRequired}
                                register={registerClientInfoFormSection2}
                                bodyStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                                errors={errors}
                                onChange={() => setMasterServicesAgreementRequired(!masterServicesAgreementRequired)}
                            />
                            {showMsaDateEntry && <div style={{transform: 'translateY(5px)', marginLeft: '90px', display: 'flex', alignItems: 'baseline'}}>
                                <label
                                    htmlFor={'masterServicesAgreementDatePicker'}
                                    style={{marginLeft: '50px', marginRight: '5px'}}
                                >
                                    Date MSA Signed
                                </label>
                                <DatePicker
                                    ref={registerClientInfoFormSection2}
                                    readOnly={!masterServicesAgreementRequired}
                                    className={'project-billing half-width-margin'}
                                    name={'masterServicesAgreementDatePicker'}
                                    // selected={!!masterServicesAgreementDate ? masterServicesAgreementDate as Date : null}
                                    onChange={(date) => setMsaDateDirty(date)}
                                    placeholderText="Select a date"
                                    value={!!masterServicesAgreementDate ? (masterServicesAgreementDate as Date).toLocaleDateString() : ''}
                                />
                                {!!masterServicesAgreementRequired && !masterServicesAgreementDate && <div style={{ color: 'red' }}>Date is required</div>}
                            </div>}
                        </div>
                        {/* RHFCheckbox's own wrapping div (.form-field) carries a global,
                            unscoped `width: 100%` rule from _leaseInfo.scss that fights any
                            width/flex-basis passed via bodyStyle. Sidestepping it: each checkbox
                            gets its own outer div with a manually-sized fixed width (based on its
                            label's length) so .form-field's 100% just fills that safely, split
                            across two explicit rows rather than relying on flex-wrap to auto-size
                            nowrap labels correctly. */}
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <div style={{width: '330px', flexShrink: 0}}>
                                <RHFCheckbox
                                    label="Sub-Consultant Agreements Required?"
                                    style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    name={'subConsultantAgreement'}
                                    checked={subConsultantAgreementRequired}
                                    register={registerClientInfoFormSection2}
                                    bodyStyle={{verticalAlign: 'middle', marginTop: '.5rem' }}
                                    onChange={() => setSubConsultantAgreementRequired(!subConsultantAgreementRequired)}
                                    errors={errors}
                                />
                            </div>
                            <div style={{width: '310px', flexShrink: 0}}>
                                <RHFCheckbox
                                    label="Partnership Agreements Required?"
                                    style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    name={`partnerAgreementRequired`}
                                    checked={partnerAgreementRequired}
                                    onChange={() => setPartnerAgreementRequired(!partnerAgreementRequired)}
                                    register={registerClientInfoFormSection2}
                                    bodyStyle={{ verticalAlign: 'middle', marginTop: '.5rem' }}
                                    errors={errors}
                                />
                            </div>
                            <div style={{width: '320px', flexShrink: 0}}>
                                <RHFCheckbox
                                    label="Non-Disclosure Agreement Required?"
                                    style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                                    name={`ndaRequired`}
                                    checked={ndaRequired}
                                    onChange={() => setNdaRequired(!ndaRequired)}
                                    register={registerClientInfoFormSection2}
                                    bodyStyle={{ verticalAlign: 'middle', marginTop: '.5rem' }}
                                    errors={errors}
                                />
                            </div>
                        </div>
                </form>
            </>
        );
    };

    const generateUpdatePayload = () => {
        const updatePayload = new TsdiClientInfo();
        const updatedFormData = getValuesClientInfoForm() as Partial<TsdiClientInfo>;
        const updatedSection2FormData = getValuesClientInfoFormSection2() as Partial<TsdiClientInfo>;
        updatePayload.address = (updatedFormData?.address === undefined || updatedFormData.address === '') ? null : updatedFormData.address;
        updatePayload.address2 = (updatedFormData?.address2 === undefined || updatedFormData.address2 === '') ? null : updatedFormData.address2;
        updatePayload.address3 = (updatedFormData?.address3 === undefined || updatedFormData.address3 === '') ? null : updatedFormData.address3;
        updatePayload.useBillingAddress = updatedFormData?.useBillingAddress === undefined ? null : updatedFormData.useBillingAddress;
        if (updatePayload.useBillingAddress !== null) {
            updatePayload.billingAddress = (updatedFormData?.billingAddress === undefined || updatedFormData.billingAddress === '') ? null : updatedFormData.billingAddress;
            updatePayload.billingAddress2 = (updatedFormData?.billingAddress2 === undefined || updatedFormData.billingAddress2 === '') ? null : updatedFormData.billingAddress2;
            updatePayload.billingAddress3 = (updatedFormData?.billingAddress3 === undefined || updatedFormData.billingAddress2 === '') ? null : updatedFormData.billingAddress3;
            updatePayload.billingCountry = (updatedFormData?.billingCountry === undefined || updatedFormData.billingCountry === '') ? null : updatedFormData.billingCountry;
            updatePayload.billingClientName = (updatedFormData?.billingClientName === undefined || updatedFormData.billingClientName === '') ? null : updatedFormData.billingClientName;
            updatePayload.billingCity = (updatedFormData?.billingCity === undefined || updatedFormData.billingCity === '') ? null : updatedFormData.billingCity;
            updatePayload.billingState = (updatedFormData?.billingState === undefined || updatedFormData.billingState === '') ? null : updatedFormData.billingState;
            updatePayload.billingZipCode = updatedFormData?.billingZipCode === undefined ? null : updatedFormData.billingZipCode;
        }
        updatePayload.clientName = (updatedFormData?.clientName === undefined || updatedFormData.clientName === '') ? null : updatedFormData.clientName;
        updatePayload.country = (updatedFormData?.country === undefined || updatedFormData.country === '') ? null : updatedFormData.country;
        updatePayload.city = (updatedFormData?.city === undefined || updatedFormData.city === '') ? null : updatedFormData.city;
        updatePayload.state = (updatedFormData?.state === undefined || updatedFormData.state === '') ? null : updatedFormData.state;
        updatePayload.zipCode = updatedFormData?.zipCode === undefined ? null : updatedFormData.zipCode;
        updatePayload.phone = (updatedFormData?.phone === undefined || updatedFormData.phone === '') ? null : updatedFormData.phone;
        updatePayload.fax = (updatedFormData?.fax === undefined || updatedFormData.fax === '') ? null : updatedFormData.fax;
        updatePayload.fax = (updatedFormData?.fax === undefined || updatedFormData.fax === '') ? null : updatedFormData.fax;
        updatePayload.emailAddress = (updatedFormData?.emailAddress === undefined || updatedFormData.emailAddress === '') ? null : updatedFormData.emailAddress;

        updatePayload.attachedDocuments = updatedSection2FormData?.attachedDocuments === undefined ? null : updatedSection2FormData.attachedDocuments;
        updatePayload.masterServicesAgreement = updatedSection2FormData?.masterServicesAgreement === undefined ? null : updatedSection2FormData.masterServicesAgreement;
        updatePayload.noGiftPolicy = updatedSection2FormData?.noGiftPolicy === undefined ? null : updatedSection2FormData.noGiftPolicy;
        updatePayload.workOrderRequired = updatedSection2FormData?.workOrderRequired === undefined ? null : updatedSection2FormData.workOrderRequired;
        updatePayload.partnerAgreementRequired = updatedSection2FormData?.partnerAgreementRequired === undefined ? null : updatedSection2FormData.partnerAgreementRequired;
        updatePayload.ndaRequired = updatedSection2FormData?.ndaRequired === undefined ? null : updatedSection2FormData.ndaRequired;
        // tslint:disable-next-line
        if (!!updatePayload.masterServicesAgreement) {
            updatePayload.masterServicesAgreementDate = !!masterServicesAgreementDate ? masterServicesAgreementDate as Date : null;
        } else {
            updatePayload.masterServicesAgreementDate = null;
        }
        updatePayload.subConsultantAgreement = updatedSection2FormData?.subConsultantAgreement === undefined ? null : updatedSection2FormData.subConsultantAgreement;
        updatePayload.clientFormatType = (updatedSection2FormData?.clientFormatType === undefined || updatedSection2FormData.clientFormatType === '') ? null : updatedSection2FormData.clientFormatType;
        updatePayload.clientNumber = selectedClient?.clientNumber;

        return updatePayload;
    };

    const onSaveChanges = () => {
        if (!!masterServicesAgreementRequired && !masterServicesAgreementDate) {
            return;
        }
        if (isDirty || isDirtyClientInfoForm || isDirtyClientInfoFormSection2) {
            const payload = generateUpdatePayload();
            updateClientInfo(payload);
        }
    };

    return (
        <div>
            <CPNavBar/>
            <div>
                {toast && (
                    <PersonnelToast
                        message={toast.message}
                        color={toast.color}
                        onClose={() => setToast(null)}
                        persistent={toast.persistent}
                    />
                )}
            </div>
            <ClientProjectSearch
                totalClients={totalClients}
                setSelectedClient={setSelectedClient}
                selectedClient={selectedClient}
                clients={clients}
                size={4}
            />
            <div style={{display: 'flex', width: '100vw', justifyContent: 'center'}}>
                <form id="clientInfoForm" onSubmit={handleSubmit(onSaveChanges)}>
                    <Page className="client-maintenance-page-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0', justifyContent: 'center' }}>
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <label style={{width: 'auto', marginRight: '.5rem', whiteSpace: 'nowrap'}}>Client #</label>
                                                <RHFInputBox
                                                    name={'clientNumber'}
                                                    bodyStyle={{width: 'auto'}}
                                                    style={{width: '70px'}}
                                                    register={register}
                                                />
                                            </div>
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Client"
                                                reactIcon={BsSearch}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => findClient(false)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Client"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => findClient(true)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Show First Client"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToFirstClient()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Show Previous Client"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToPreviousClient()}
                                            />
                                            <input
                                                id={'selectClientPosition'}
                                                type="text"
                                                inputMode="numeric"
                                                value={clientPositionInput}
                                                onChange={(e) => handleClientPositionInputChange(e)}
                                                title="Enter a position to jump to it"
                                                style={{
                                                    fontWeight: 'bold',
                                                    marginLeft: '1rem',
                                                    width: '3rem',
                                                    textAlign: 'center',
                                                    border: clientPositionError ? '2px solid red' : '1px solid #ccc',
                                                    borderRadius: '4px',
                                                    outline: 'none'
                                                }}
                                            />
                                            <label style={{ width: 'auto', marginLeft: '.5rem', marginRight: '.2rem' }}>of</label>
                                            <label style={{ width: 'auto', fontWeight: 'bold' }}>{totalClientTableCount}</label>
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Show Next Client"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToNextClient()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Show Last Client"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToLastClient()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                type={'submit'}
                                                title="Save Changes"
                                                reactIcon={FaRegSave}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            />
                                            {clientPositionError &&
                                                <label style={{ color: 'red', marginLeft: '1rem' }}>{clientPositionError}</label>
                                            }
                                            <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Prospect by Manager"
                                                reactIcon={FaUserTie}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Not implemented!')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Manage Documents"
                                                reactIcon={FaFolderOpen}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => showDocumentManagement()}
                                            />
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="client-maintenance-page-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle="Client Information">
                                    <div style={{ padding: '.5rem', height: '40rem', overflow: 'auto' }}>
                                        <div>
                                            {displayClientInfo()}
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle="Client Billing Address">
                                    <div style={{ padding: '.5rem', height: '40rem', overflow: 'auto' }}>
                                        <div>
                                            {displayClientBillingAddress()}
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="client-maintenance-page-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel>
                                    <div className="form-row" style={{ marginBottom: '0' }}>
                                        <div style={{ width: '100%', textAlign: 'left', overflowY: 'auto', overflowX: 'hidden' }}>
                                            {displayClientConfiguration()}
                                        </div>
                                    </div>
                                    <label id="BillingCodeError" style={{display: 'none', color: 'red'}}>Test</label>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </form>
            </div>
            <FindClientDialog 
                dialogName={DialogList.FIND_CLIENT}
                hideDialog={hideDialog}
                clients={clients}
                setClientSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                incrementClients={incrementClients}
                addNewClient={addingClient}
                setSelectedClient={setSelectedClient}
                mileageRate={currentMileageRate}
                onAddNewClient={addTsdiClient}
                onDuplicateClientName={handleDuplicateClientName}
                invoiceTypes={tsdiAccounts}
                clientTypes={clientTypes}
            />
            <ClientAlreadyExistsWarningDialog
                dialogName={DialogList.CLIENT_NAME_EXISTS}
                hideDialog={closeDuplicateClientNameWarning}
                onConfirm={confirmDuplicateClientCreate}
                heading={'Client Already Exists'}
                label={'A client with this name already exists. OK to create it anyway, Cancel to go back.'}
            />
            <ReportOptionsDialog
                dialogName={DialogList.REPORT_OPTIONS}
                hideDialog={hideDialog}
                handleReport={handleReport}
                showDialog={showDialog}
                reportTypes={[
                    { value: 0, label: 'Client Name And Address' },
                    { value: 1, label: 'Prospect Information' },
                    { value: 2, label: 'Active Prospect List' },
                    { value: 3, label: 'Active Prospect Mileage' },
                    { value: 4, label: 'Prospect Mileage' },
                    { value: 5, label: 'Prospect by Pay Period ' },
                    { value: 6, label: 'Postage Tally Sheet ' },
                    { value: 7, label: 'Fax Tally Sheet ' },
                    { value: 8, label: 'Supply Tally Sheet' },
                    { value: 9, label: 'Client Landman List' }
                ]}
                parentType={2}
                sortOptions={[
                    { value: 0, label: 'Client Name' },
                    { value: 1, label: 'Client Number' }
                ]}
            />
            <ClientDocumentManagementDialog
                dialogName={DialogList.MANAGE_CLIENT_DOCUMENTS}
                hideDialog={hideDialog}
                clientNumber={selectedClient?.clientNumber}
                documentList={clientDocs}
                addDocument={handleAddClientDoc}
                deleteDocument={handleDeleteClientDoc}
                downloadDocument={handleDownloadClientDoc}
            />
        </div>
    );
};

export default ClientMaintenancePage;



// WEBPACK FOOTER //
// ./src/components/client-project/pages/ClientMaintenancePage.tsx